import { Component, OnInit, ElementRef, ViewChild, OnDestroy } from '@angular/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators, FormControl, FormArray } from '@angular/forms';
import { BannerService } from '../../../services/banner.service';
import { CommonService } from '../../../services/common.service';
import { TokenStorageService } from 'src/app/services/token-storage.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { FileUpload } from 'primeng/fileupload';
import { ImageCroppedEvent, ImageTransform } from 'ngx-image-cropper';

@Component({
    selector: 'app-banner-edit',
    templateUrl: './edit.component.html',
    styleUrls: ['./edit.component.scss'],
    providers: [ConfirmationService, MessageService]
})

export class BannerEditComponent implements OnInit, OnDestroy {

    private destroy$ = new Subject<void>();
    id;
    bannerForm: FormGroup;
    submitted = false;
    uploadedFiles: any[] = [];
    mobileUploadedFiles: any[] = [];
    file: File;
    reader: FileReader;
    public profilepic;
    errorMessage = '';
    public item: any[] = [];
    countrylist: any = [];
    statelist: any = [];
    citylist: any = [];
    genders: any = [];
    public bannerImage;
    public bannerImages;
    public mobileBannerImages;
    public imageBanner;
    showProfile = false;
    statuses: any = [];
    bannerStatus: any;
    banner_title;
    banner_content;
    banner_url;
    selectedStatus: any;
    displayCustom: boolean;
    activeIndex: number = 0;
    removeImagesArr: any[] = [];
    removedImage;
    updatedBannerImages: any[] = [];
    responsiveOptions: any[] = [
        {
            breakpoint: '1024px',
            numVisible: 5
        },
        {
            breakpoint: '768px',
            numVisible: 3
        },
        {
            breakpoint: '560px',
            numVisible: 1
        }
    ];
    deletedImages: any[] = [];
    updatedBannerImagesArray: any;
    updatedMobileBannerImages: any[] = [];
    updatedMobileBannerImagesArray: any;
    public loggedInUser;
    public userId;
    public userRoleId;
    public bannerModule;
    public loggedInUserPermissions;
    public bannerPermissions: any[] = [];
    public deletedMobileImages: any[] = [];
    public showMobileProfile: boolean = false;
    sampleBannerImageLinkArray: any[] = [];
    sampleMobileBannerImageLinkArray: any[] = [];
    bannerImageTypes: { label: string; value: string; }[];
    bannerImageType: any[] = [];
    mobileBannerImageType: any[] = [];
    @ViewChild('fileUpload1') fileUpload1!: FileUpload;
    @ViewChild('fileUpload2') fileUpload2!: FileUpload;
    imageChangedEvent: any = '';
    croppedImage: any = '';
    imageSize = 1000000;
    croppedImageMaxSize = 1000000;
    croppedImageSize = 0;
    croppedImageError: string | null = null;
    imageQueue: any[] = [];
    currentImageIndex: number = 0;
    cropDialog: boolean = false;
    fileUploader: 'webBannerImage' | 'mobileBannerImage' | string = 'webBannerImage';
    showInstructionModal: boolean = false;
    scale = 1;
    transform: ImageTransform = {};
    isApplyingCrop = false;
    batchCropCompleted = false;
    private cropApplyUnlockTimer: any = null;

    get cropDialogTitle(): string {
        return this.fileUploader === 'webBannerImage'
            ? 'Crop & Adjust Web Banner Image'
            : 'Crop & Adjust Mobile Banner Image';
    }

    get cropDialogSubtitle(): string {
        const progress = this.imageQueue.length > 1
            ? `Photo ${this.currentImageIndex + 1} of ${this.imageQueue.length} - `
            : '';
        const size = this.fileUploader === 'webBannerImage' ? '1024 x 512' : '1500 x 1050';
        return `${progress}position and scale your image for a ${size} crop`;
    }

    get cropPreviewLabel(): string {
        return this.fileUploader === 'webBannerImage'
            ? '1024 x 512 px - High Quality JPEG'
            : '1500 x 1050 px - High Quality JPEG';
    }

    zoomIn() {
        this.scale = Math.min(3, Number((this.scale + 0.1).toFixed(1)));
        this.transform = {
            ...this.transform,
            scale: this.scale
        };
    }

    zoomOut() {
        this.scale = Math.max(0.1, Number((this.scale - 0.1).toFixed(1)));
        this.transform = {
            ...this.transform,
            scale: this.scale
        };
    }

    showSafeGuide: boolean = true;

    toggleSafeGuide() {
        this.showSafeGuide = !this.showSafeGuide;
    }

    resetZoom() {
        this.scale = 1;
        this.transform = {
            ...this.transform,
            scale: 1
        };
    }

    constructor(private bannerService: BannerService, private commonService: CommonService, private formBuilder: FormBuilder,
        private confirmationService: ConfirmationService, private messageService: MessageService,
        private router: Router, private activeroute: ActivatedRoute, private elementRef: ElementRef,
        private tokenStorageService: TokenStorageService) { }

    ngOnInit(): void {
        this.loggedInUser = this.tokenStorageService.getUser();
        this.userId = this.loggedInUser.userdata.id;
        this.userRoleId = this.loggedInUser.userdata.role;

        this.bannerModule = "Banner Management";
        this.loggedInUserPermissions = this.tokenStorageService.getUserPermissions();

        this.loggedInUserPermissions.forEach(permission => {
            if (permission.module == this.bannerModule) {
                let permissionObj = {
                    moduleName: permission.module,
                    status: permission.status,
                    permission: permission.permission
                }
                this.bannerPermissions.push(permissionObj);
            }
        });
        if (this.bannerPermissions.length == 0) {
            this.router.navigateByUrl('/manage/dashboard')
        }
        this.bannerPermissions = this.bannerPermissions[0]['permission'];


        this.id = this.activeroute.snapshot.params.id;
        this.statuses = [
            { name: 'Active', code: 'Active' },
            { name: 'In-Active', code: 'In-Active' }
        ];
        this.bannerImageTypes = [
            { label: 'Internal', value: 'Internal' },
            { label: 'External', value: 'External' }
        ];
        this.getBannerDetails(this.id);
        this.bannerForm = this.formBuilder.group({
            banner_title: ['', [Validators.required, Validators.pattern('^[A-Za-z_ ][A-Za-z_ ]*$')]],
            slug: ['', [Validators.required, Validators.pattern('^[A-Za-z_][A-Za-z_]*$')]],
            mobile_banner_title: ['', [Validators.required, Validators.pattern('^[A-Za-z_ ][A-Za-z_ ]*$')]],
            mobile_slug: ['', [Validators.required, Validators.pattern('^[A-Za-z_][A-Za-z_]*$')]],
            // banner_content: [''],
            // banner_url : ['', [Validators.required, Validators.pattern('(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?')]], 
            banner_image_links: this.formBuilder.array([]),
            update_bannerImageLink_info: this.formBuilder.array([]),
            mobile_banner_image_links: this.formBuilder.array([]),
            update_mobileBannerImageLink_info: this.formBuilder.array([]),
            status: ['', Validators.required],
        });


    }

    bannerImageLinksArray() {
        return this.bannerForm.get('banner_image_links') as FormArray;
    }

    updateBannerImageLinksArray() {
        return this.bannerForm.get('update_bannerImageLink_info') as FormArray;
    }

    mobileBannerImageLinksArray() {
        return this.bannerForm.get('mobile_banner_image_links') as FormArray;
    }

    updateMobileBannerImageLinksArray() {
        return this.bannerForm.get('update_mobileBannerImageLink_info') as FormArray;
    }

    onWebBannerImageOrderInput(event, index) {
        const value = (event.target as HTMLInputElement).value;
        this.updateBannerImageLinksArray().at(index)['controls']['order'].setValue((value !== '') ? Number(value): null);
    }

    onWebBannerImageLinkInput(event, index) {
        const value = (event.target as HTMLInputElement).value;
        this.updateBannerImageLinksArray().at(index)['controls']['bannerImageLink'].setValue(value);
    }

    onWebBannerImageLinkTypeSelect(event, index) {
        const value = (event.value !== null) ? event.value.value : null;
        this.updateBannerImageLinksArray().at(index)['controls']['bannerImageLinkType'].setValue(value);
    }

    onMobileBannerImageOrderInput(event, index) {
        const value = (event.target as HTMLInputElement).value;
        this.updateMobileBannerImageLinksArray().at(index)['controls']['order'].setValue((value !== '') ? Number(value): null);
    }

    onMobileBannerImageLinkInput(event, index) {
        const value = (event.target as HTMLInputElement).value;
        this.updateMobileBannerImageLinksArray().at(index)['controls']['mobileBannerImageLink'].setValue(value);
    }

    onMobileBannerImageLinkTypeSelect(event, index) {
        const value = (event.value !== null) ? event.value.value : null;
        this.updateMobileBannerImageLinksArray().at(index)['controls']['mobileBannerImageLinkType'].setValue(value);
    }

    getBannerDetails(id) {
        this.bannerService.getBannerDetails(id).pipe(takeUntil(this.destroy$)).subscribe(
            data => {
                this.item = data;
                if (this.item) {
                    this.bannerForm.patchValue({
                        banner_title: this.item['banner_title'],
                        // banner_content: this.item['banner_content'],
                        slug: this.item['slug'],
                        mobile_banner_title: this.item['mobile_banner_title'],
                        mobile_slug: this.item['mobile_slug'],
                        //banner_url: this.item['banner_url']
                    });
                    this.bannerForm.get('status').setValue(this.item['status']);
                    this.bannerForm.controls['slug'].disable();
                    this.bannerForm.controls['mobile_slug'].disable();
                    if (this.item['banner_image'] != undefined) {
                        this.bannerImages = this.item['banner_image'];
                        this.bannerImages.forEach((element, index) => {
                            this.bannerImageType.push(this.bannerImageTypes.find(ele => ele.value === element.bannerImageLinkType) ?? null);
                            this.bannerForm.addControl("default_name_" + index, new FormControl());
                            const updateBannnerImageInfoFormGroup: FormGroup = new FormGroup({
                                order: new FormControl(element.order, Validators.required),
                                bannerImageLink: new FormControl(element.bannerImageLink,Validators.pattern(/^https?:\/\/[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}(\/.*)?$/)),
                                bannerImageLinkType: new FormControl(element.bannerImageLinkType),
                                id: new FormControl(element.id)
                            });
                            this.updateBannerImageLinksArray().push(updateBannnerImageInfoFormGroup);
                            // element['id'] = index;
                            if (element.default == true) {
                                this.bannerForm.get("default_name_" + index).setValue(false);
                            }
                        });
                        this.showProfile = true;
                    } else {
                        this.showProfile = false;
                    }
                    if (this.item['mobile_banner_image'] != undefined) {
                        this.mobileBannerImages = this.item['mobile_banner_image'];
                        this.mobileBannerImages.forEach((element, index) => {
                            this.mobileBannerImageType.push(this.bannerImageTypes.find(ele => ele.value === element.mobileBannerImageLinkType) ?? null);
                            this.bannerForm.addControl("default_mobile_name_" + index, new FormControl());
                            const updateMobileBannnerImageInfoFormGroup: FormGroup = new FormGroup({
                                order: new FormControl(element.order, Validators.required),
                                mobileBannerImageLink: new FormControl(element.mobileBannerImageLink, Validators.pattern(/^https?:\/\/[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}(\/.*)?$/)),
                                mobileBannerImageLinkType: new FormControl(element.mobileBannerImageLinkType),
                                id: new FormControl(element.id)
                            });
                            this.updateMobileBannerImageLinksArray().push(updateMobileBannnerImageInfoFormGroup);
                            // element['id'] = index;
                            if (element.default == true) {
                                this.bannerForm.get("default_mobile_name_" + index).setValue(false);
                            }
                        });
                        this.showMobileProfile = true;
                    } else {
                        this.showMobileProfile = false;
                    }
                }

            },
            err => {
                this.errorMessage = err.error.message;
            }
        );
    }
    get f() {
        return this.bannerForm.controls;
    }
    changeDefault(event, banner) {
        let id = banner.id;
        this.bannerImages.forEach((item, index) => {
            let obj = { id: item.id, banner_image_src: item.banner_image_src, alt: item.alt, default: item.default };
            if (item.id == id) {
                obj = { id: item.id, banner_image_src: item.banner_image_src, alt: item.alt, default: true };
                let removeDefault = this.findIndexByName(item.banner_image_src, this.bannerImages);
                if (removeDefault != -1) {
                    this.bannerImages[removeDefault] = obj;
                    this.bannerForm.get("default_name_" + item.id).setValue(false);
                }
            } else {
                obj = { id: item.id, banner_image_src: item.banner_image_src, alt: item.alt, default: false };
                const defaultIndex = this.findIndexByName(item.banner_image_src, this.bannerImages);
                this.bannerImages[defaultIndex] = obj;
                this.bannerForm.get("default_name_" + item.id).setValue(true);
            }

        });
        // console.log(this.updatedBannerImages);
        // this.updatedBannerImages.forEach((element, index) => {
        //     index++;
        //     this.elementRef.nativeElement.querySelector(".p-fileupload-content .banner-images #banner_default_" + index).checked = false;
        //     // this.elementRef.nativeElement.querySelector(".p-fileupload-content .banner-images #banner_default_" + index).addEventListener("click", this.changeDefaultBanner(index), false)
        // })
    }
    findIndexByName(name, arrayName) {
        let index = -1;
        for (let i = 0; i < arrayName.length; i++) {
            if (arrayName[i].banner_image_src === name) {
                index = i;
                break;
            }
        }
        return index;
    }
    
    onMultipleFileSelect(event: any, fileUploaderName) {
        const files: File[] = Array.from(event.files || []);
        this.fileUploader = fileUploaderName;
        if (files.length === 0) {
            return;
        }
        const maxSize = 1 * 1024 * 1024;
        const validFiles: File[] = [];
        files.forEach((file: File) => {
            if (file.size > maxSize) {
                this.messageService.add({
                    key: 'toastmsg',
                    severity: 'error',
                    summary: 'Image Too Large',
                    detail: `${file.name} exceeds 1 MB`,
                    life: 4000
                });
            } else {
                validFiles.push(file);
            }
        });
        this.clearFileInput();
        if (validFiles.length === 0) {
            return;
        }
        this.batchCropCompleted = false;
        this.isApplyingCrop = false;
        this.imageQueue = [...validFiles];
        this.currentImageIndex = 0;
        this.loadCropperImage();
    }

    loadCropperImage(fromQueueTransition: boolean = false) {
        this.clearCropApplyUnlockTimer();
        const file = this.imageQueue[this.currentImageIndex];
        if (!file) {
            this.cropDialog = false;
            return;
        }
        this.croppedImage = null;
        this.resetCropValidation();
        this.resetZoom();
        this.isApplyingCrop = fromQueueTransition;
        this.imageChangedEvent = {
            target: {
                files: [file]
            }
        };
        this.cropDialog = true;
        if (fromQueueTransition) {
            const expectedIndex = this.currentImageIndex;
            this.cropApplyUnlockTimer = setTimeout(() => {
                if (this.cropDialog && this.currentImageIndex === expectedIndex) {
                    this.isApplyingCrop = false;
                }
                this.cropApplyUnlockTimer = null;
            }, 600);
        }
    }

    imageCropped(event: ImageCroppedEvent) {
        this.croppedImage = event.base64;
        this.croppedImageSize = this.getBase64SizeBytes(this.croppedImage);
        this.croppedImageError = this.croppedImageSize > this.croppedImageMaxSize
            ? 'Cropped image size must not exceed 1 MB.'
            : null;
    }

    onCropImageLoadFailed() {
        this.croppedImage = null;
        this.croppedImageSize = 0;
        this.croppedImageError = 'This image could not be loaded. Please choose a valid image file.';
    }

    getBase64SizeBytes(base64: string): number {
        if (!base64) return 0;
        return Math.round(
            (base64.length * (3 / 4)) -
            (base64.split(',')[0].length + 1)
        );
    }

    applyCrop() {
        if (this.isApplyingCrop || this.croppedImageError || !this.croppedImage) return;
        const currentFile = this.imageQueue[this.currentImageIndex];
        if (!currentFile) {
            this.croppedImageError = 'The selected image is no longer available. Cancel and choose it again.';
            return;
        }

        this.isApplyingCrop = true;
        const croppedFile = this.base64ToFile(
            this.croppedImage,
            this.getOutputFileName(currentFile.name)
        );
        if (croppedFile.size > this.croppedImageMaxSize) {
            this.croppedImageError = 'Cropped image size must not exceed 1 MB.';
            this.isApplyingCrop = false;
            return;
        }

        const uploadEvent = { files: [croppedFile] };
        if (this.fileUploader === 'webBannerImage') {
            this.picUploader(uploadEvent);
        } else {
            this.mobilePicUploader(uploadEvent);
        }

        this.currentImageIndex++;
        if (this.currentImageIndex < this.imageQueue.length) {
            this.loadCropperImage(true);
        } else {
            this.finishUploadFlow();
        }
    }

    finishUploadFlow() {
        this.batchCropCompleted = true;
        this.cropDialog = false;
    }

    onCropCancel() {
        this.batchCropCompleted = false;
        this.cropDialog = false;
    }

    onDialogHide() {
        this.resetCropFlow();
    }

    private resetCropFlow() {
        this.clearCropApplyUnlockTimer();
        this.imageQueue = [];
        this.currentImageIndex = 0;
        this.imageChangedEvent = null;
        this.croppedImage = null;
        this.resetCropValidation();
        this.resetZoom();
        this.batchCropCompleted = false;
        this.isApplyingCrop = false;
        this.clearFileInput();
    }

    private clearCropApplyUnlockTimer() {
        if (this.cropApplyUnlockTimer) {
            clearTimeout(this.cropApplyUnlockTimer);
            this.cropApplyUnlockTimer = null;
        }
    }

    private clearFileInput() {
        if (this.fileUpload1) {
            this.fileUpload1.clear();
        }
        if (this.fileUpload2) {
            this.fileUpload2.clear();
        }
        const fileInputs = this.elementRef?.nativeElement?.querySelectorAll('input[type="file"]');
        if (fileInputs) {
            fileInputs.forEach((input: HTMLInputElement) => {
                input.value = '';
            });
        }
    }

    resetCropValidation() {
        this.croppedImageError = null;
        this.croppedImageSize = 0;
    }

    base64ToFile(data: string, filename: string): File {
        const arr = data.split(',');
        const mime = arr[0].match(/:(.*?);/)[1];
        const bstr = atob(arr[1]);
        let n = bstr.length;
        const u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new File([u8arr], filename, { type: mime });
    }

    private getOutputFileName(filename: string | undefined): string {
        const defaultPrefix = this.fileUploader === 'webBannerImage' ? 'web-banner' : 'mobile-banner';
        const timestamp = new Date().getTime();
        const baseName = (filename || defaultPrefix).replace(/\.[^/.]+$/, '');
        return `${baseName}_${timestamp}.jpg`;
    }

    picUploader(event) {
        let index = 0;
        for (let file of event.files) {
            this.uploadedFiles.push(file);
            let reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => { // called once readAsDataURL is completed
                if (reader.result != null) {
                    this.updatedBannerImages.push({
                        'file': reader.result,
                        'name': file.name,
                        'size': file.size
                    });
                    index++;
                    if (!this.sampleBannerImageLinkArray.includes(file.name)) {
                        this.sampleBannerImageLinkArray.push(file.name);

                        const bannerImageLinkFormGroup = this.formBuilder.group({
                            order: [null,[Validators.required]],
                            bannerImageLink: ['', Validators.pattern(/^https?:\/\/[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}(\/.*)?$/)],
                            bannerImageLinkType: [null]
                        });
                        this.bannerImageLinksArray().push(bannerImageLinkFormGroup);
                    }
                }
            }
        }
    }

    removeUploadedBannerImage(index: number) {
        this.sampleBannerImageLinkArray.splice(index, 1);
        this.updatedBannerImages.splice(index, 1);
        if (this.uploadedFiles && this.uploadedFiles[index]) {
            this.uploadedFiles.splice(index, 1);
        }
        this.bannerImageLinksArray().removeAt(index);
    }

    removeBannerImage(event) {
        const webBannerImageindex = this.sampleBannerImageLinkArray.findIndex(ele => ele === event.file.name);
        if (webBannerImageindex > -1) {
            this.removeUploadedBannerImage(webBannerImageindex);
        }
    }

    mobilePicUploader(event) {
        let index = 0;
        for (let file of event.files) {
            this.mobileUploadedFiles.push(file);
            let reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => { // called once readAsDataURL is completed
                if (reader.result != null) {
                    this.updatedMobileBannerImages.push({
                        'file': reader.result,
                        'name': file.name,
                        'size': file.size
                    });
                    index++;
                    if (!this.sampleMobileBannerImageLinkArray.includes(file.name)) {
                        this.sampleMobileBannerImageLinkArray.push(file.name);
                        const mobileBannerImageLinkFormGroup = this.formBuilder.group({
                            order: [null,[Validators.required]],
                            mobileBannerImageLink: ['', Validators.pattern(/^https?:\/\/[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}(\/.*)?$/)],
                            mobileBannerImageLinkType: [null]
                        });
                        this.mobileBannerImageLinksArray().push(mobileBannerImageLinkFormGroup);
                    }
                }
            }
        }
    }

    removeUploadedMobileBannerImage(index: number) {
        this.sampleMobileBannerImageLinkArray.splice(index, 1);
        this.updatedMobileBannerImages.splice(index, 1);
        if (this.mobileUploadedFiles && this.mobileUploadedFiles[index]) {
            this.mobileUploadedFiles.splice(index, 1);
        }
        this.mobileBannerImageLinksArray().removeAt(index);
    }

    removeMobileBannerImage(event) {
        const mobileBannerImageindex = this.sampleMobileBannerImageLinkArray.findIndex(ele => ele === event.file.name);
        if (mobileBannerImageindex > -1) {
            this.removeUploadedMobileBannerImage(mobileBannerImageindex);
        }
    }

    formatFileSize(bytes: number): string {
        if (!bytes || bytes === 0) return '0 B';
        const k = 1024;
        const sizes = ['B', 'KB', 'MB', 'GB'];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(3)) + ' ' + sizes[i];
    }

    ngAfterViewInit(): void {

        this.updatedBannerImages.forEach((element, index) => {
            index++;
            let clickStream;
            //this.elementRef.nativeElement.querySelector(".p-fileupload-content .banner-images #banner_default_" + index).checked = false;
            this.elementRef.nativeElement.querySelector(".p-fileupload-content .banner-images #banner_default_" + index).addEventListener("click", () => {
                let click = this.changeDefaultBanner(this, index);
                this.elementRef.nativeElement.querySelector(".p-fileupload-content .banner-images #banner_default_" + index).addEventListener('click', click)
                //el.nativeElement.addEventListener('mouseup', this.mouseUpRef)
            }, false);
        })
    }

    changeDefaultBanner(event, index) {
        this.bannerImages.forEach((item, index) => {
            let obj = { id: item.id, banner_image_src: item.banner_image_src, alt: item.alt, default: false };
            const defaultIndex = this.findIndexByName(item.banner_image_src, this.bannerImages);
            this.bannerImages[defaultIndex] = obj;
            this.bannerForm.get("default_name_" + item.id).setValue(true);
        });
    }
    getCountry() {
        this.commonService.getCountryList().pipe(takeUntil(this.destroy$)).subscribe(
            data => {
                this.countrylist = data.data.items;
            },
            err => {
                this.errorMessage = err.error.message;
            }
        );
    }
    onStatusSelect(event) {
        if (event) {
            this.bannerStatus = event.name;
        }
    }
    onSubmit() {
        this.submitted = true;
        if (this.bannerForm.invalid) {
            return;
        }
        var bannerData = this.bannerForm.value;
        this.updatedBannerImagesArray = [];
        this.updatedMobileBannerImagesArray = [];
        if (this.updatedBannerImages != undefined) {
            this.updatedBannerImages.forEach((element, index) => {
                index = index + 1;
                let bannerImageAlt = null;
                let bannerImageDefault = null;
                // let bannerImageAlt = this.elementRef.nativeElement.querySelector(".p-fileupload-content .banner-images #banner_image_" + index).value;
                // let bannerImageDefault = this.elementRef.nativeElement.querySelector(".p-fileupload-content .banner-images #banner_default_" + index).checked;
                this.updatedBannerImagesArray.push({ 'file': element.file, 'alt': bannerImageAlt, 'default': bannerImageDefault });

            });
        }

        this.bannerImageLinksArray().value.forEach((ele, index) => {
            this.updatedBannerImagesArray[index]['order'] = ele['order'];
            this.updatedBannerImagesArray[index]['bannerImageLink'] = ele['bannerImageLink'];
            this.updatedBannerImagesArray[index]['bannerImageLinkType'] = ele['bannerImageLinkType']?.value ?? null;
        })

        if (this.updatedMobileBannerImages != undefined) {
            this.updatedMobileBannerImages.forEach((element, index) => {
                index = index + 1;
                let bannerImageAlt = null;
                let bannerImageDefault = null;
                this.updatedMobileBannerImagesArray.push({ 'file': element.file, 'alt': bannerImageAlt, 'default': bannerImageDefault });

            });
        }


        this.mobileBannerImageLinksArray().value.forEach((ele, index) => {
            this.updatedMobileBannerImagesArray[index]['order'] = ele['order'];
            this.updatedMobileBannerImagesArray[index]['mobileBannerImageLink'] = ele['mobileBannerImageLink'];
            this.updatedMobileBannerImagesArray[index]['mobileBannerImageLinkType'] = ele['mobileBannerImageLinkType']?.value ?? null;
        })
        bannerData['banner_images'] = this.updatedBannerImagesArray;
        bannerData['mobile_banner_images'] = this.updatedMobileBannerImagesArray;
        bannerData['deleted_images'] = this.deletedImages;
        bannerData['deleted_mobile_images'] = this.deletedMobileImages;
        delete bannerData['banner_image_links'];
        delete bannerData['mobile_banner_image_links'];
        console.log(bannerData);
        bannerData = JSON.stringify(bannerData, null, 4);
        // console.log(bannerData); return;
        this.bannerService.updateBanner(this.id, bannerData).pipe(takeUntil(this.destroy$)).subscribe(
            data => {
                this.messageService.add({ key: 'toastmsg', severity: 'success', summary: 'Successful', detail: 'Banner Data Updated Successfully!!', life: 6000 });
                setTimeout(() => {
                    this.router.navigate(['/manage/banner']);
                }, 2000);
            },
            err => {
                //this.errorMessage = err.error.message;
            }
        );
    }
    onReset() {
        this.submitted = false;
        this.bannerForm.reset();
    }

    backLink() {
        this.router.navigate(['/manage/banner']);
    }
    imageClick(index: number) {
        this.activeIndex = index;
        this.displayCustom = true;
    }

    removeBannerImages(item: any): void {
        this.confirmationService.confirm({
            message: 'Are you sure you want to delete this image ?',
            header: 'Confirm',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                const bannerImage = item?.banner_image_src;
                this.deletedImages.push(item?.banner_image_src);
                const index = this.updateBannerImageLinksArray().value.findIndex(ele => ele.id === item.id);
                for (let removedImage of this.bannerImages) {
                    this.bannerImages = this.bannerImages.filter((item) => item.banner_image_src !== bannerImage);
                }
                this.updateBannerImageLinksArray().removeAt(index);
            },
            reject: () => {
                //this.getUserDetails(user.id);
            }
        });


    }
    removeMobileBannerImages(item: any): void {
        this.confirmationService.confirm({
            message: 'Are you sure you want to delete this image ?',
            header: 'Confirm',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                const bannerImage = item?.banner_image_src;
                this.deletedMobileImages.push(item?.banner_image_src);
                const index = this.updateMobileBannerImageLinksArray().value.findIndex(ele => ele.id === item.id);
                for (let removedImage of this.mobileBannerImages) {
                    this.mobileBannerImages = this.mobileBannerImages.filter((item) => item.banner_image_src !== bannerImage);
                }
                this.updateMobileBannerImageLinksArray().removeAt(index);
            },
            reject: () => {
                //this.getUserDetails(user.id);
            }
        });


    }

    ngOnDestroy() {
        this.clearCropApplyUnlockTimer();
        this.destroy$.next();
        this.destroy$.complete();
    }
}
